module.exports = __webpack_public_path__ + "img/logo.4eeb8a8e.png";